<template>
    <div>
        <v-container fluid color="red" class="pa-0">
            <v-row>

                <v-col cols="12" v-if="isActiveProjectFound">

                    <v-card
                            flat
                            color="transparent"
                            @mouseover="cardClass='mt-3 pb-4 elevation-0'"
                            @mouseout="cardClass='mt-3 pb-4'"
                    >
                        <v-card color="grey darken-2"
                                flat
                                class="mr-5 ml-5"
                        >
                            <v-container fluid>
                                <v-row dense style="flex-wrap: nowrap;">
                                    <v-col cols=2 class="flex-grow-1 flex-shrink-0">
                                        <avatar :size="70" :image-url="manager.photo_url" :person-name="manager.name">
                                            {{manager.name}}
                                        </avatar>
                                    </v-col>
                                    <v-col cols="11" class="title flex-grow-0 flex-shrink-1">
                                        <div class="mb-0 heading font-weight-medium text-left">
                                            <div class="project-name block">
                                                {{projectName}}
                                            </div>
                                        </div>
                                        <div class="mt-0 subtitle-1 font-weight-light grey--text text--lighten-2 text-left">
                                            {{subheading}}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>

                        <v-container fluid color="red" class="pt-10 justify-space-around">
                            <v-row dense>

                                <v-col cols="3" class="text-center">
                                    <v-card-text class="pa-0">
                                        <div class="subtitle-1 text-center font-weight-light grey--text text--lighten-2">
                                            Progress
                                        </div>
                                        <v-progress-circular
                                                class="mt-3 justify-center"
                                                :size="100"
                                                :width="15"
                                                :value="progress"
                                                :color="color(progress)"
                                        >
                                            <span class="white--text">{{progress}}%</span>
                                        </v-progress-circular>
                                    </v-card-text>
                                </v-col>

                                <v-col cols="3" class="text-center">
                                    <v-card-text class="pa-0">
                                        <div class="subtitle-1 text-center font-weight-light grey--text text--lighten-2">
                                            Response rate
                                        </div>
                                        <v-progress-circular
                                                class="mt-3 justify-center"
                                                :size="100"
                                                :width="15"
                                                :value="responseRate"
                                                :color="calculateResponseRateColor(responseRate)"
                                        >
                                            <span class="white--text">{{responseRate}}%</span>
                                        </v-progress-circular>
                                    </v-card-text>
                                </v-col>

                                <!-- TIME LEFT -->
                                <v-col cols="3" class="text-center">
                                    <v-card-text class="pa-0">
                                        <div class="subtitle-1 text-center font-weight-light grey--text text--lighten-2">
                                            Time left
                                        </div>
                                        <v-progress-circular
                                                class="mt-3 justify-center"
                                                :size="100"
                                                :width="15"
                                                :value="timeLeft"
                                                :color="color(timeLeft)"
                                        >
                                            <span class="white--text">{{timeLeft}}%</span>
                                        </v-progress-circular>
                                    </v-card-text>
                                </v-col>

                                <!--RATING -->
                                <v-col cols="3" class="text-center">
                                    <v-card-text class="pa-0">
                                        <div class="subtitle-1 text-center font-weight-light grey--text text--lighten-2">
                                            Rating
                                        </div>
                                        <v-progress-circular
                                                class="mt-3 justify-center"
                                                :size="100"
                                                :width="15"
                                                :value="rating * 10"
                                                :color="calculateRatingColor(rating)"
                                        >
                                            <span class="white--text">{{rating}}</span>
                                        </v-progress-circular>
                                    </v-card-text>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>


    import moment from 'moment';
    import StatBox from '../../../components/UI/DashboardTrendValue';
    import Avatar from '../../../components/UI/Avatar';
    import {mapActions, mapState} from 'vuex';
    import {surveyRatingColor} from "../../../components/mixins/surveyRatingColorMixin";
    import {rateColorMixin} from "../../../components/mixins/rateColorMixin";

    export default {

        mixins: [surveyRatingColor, rateColorMixin],

        components: {
            StatBox,
            Avatar
        },

        props: ['name'],

        data() {
            return {
                data: [
                    {}
                ],
                cardClass: 'mt-3 pb-4'
            }
        },

        computed: {

            ...mapState('DashBoard', [
                'projectActivityStatsForLastHour',
            ]),

            isActiveProjectFound() {
                if (this.projectActivityStatsForLastHour && this.projectActivityStatsForLastHour.stats) {
                    return true;
                }
                return false;
            },

            projectName() {
                if (this.projectActivityStatsForLastHour.meta) {

                    let parts = this.projectActivityStatsForLastHour.meta.name.split(' ');
                    let length = 0;

                    let mapped = parts.map((part) => {
                        length += part.length;
                        return length > 30 ? '' : part;
                    });

                    return mapped.join(' ').toUpperCase();
                }
            },

            rating() {
                return this.projectActivityStatsForLastHour.meta.rating;
            },

            progress() {
                if (this.projectActivityStatsForLastHour.meta) {
                    return Math.round(this.projectActivityStatsForLastHour.meta.completed_count /
                        this.projectActivityStatsForLastHour.meta.target_completes * 100);
                }

                return 0;
            },

            responseRate() {
                if (this.projectActivityStatsForLastHour.meta) {

                    let responseRate = 0;

                    if (this.projectActivityStatsForLastHour.meta.invited_count > 0) {
                        responseRate =
                            this.projectActivityStatsForLastHour.meta.started_count /
                            this.projectActivityStatsForLastHour.meta.invited_count * 100;
                    }

                    return Math.round(responseRate);
                } else {
                    return 0;
                }
            },

            manager() {
                if (this.projectActivityStatsForLastHour.meta) {
                    return this.projectActivityStatsForLastHour.meta.created_by;
                }
                return null;
            },

            assistant() {
                if (this.projectActivityStatsForLastHour.meta) {
                    return this.projectActivityStatsForLastHour.meta.assistant_manager;
                }
                return null;
            },

            subheading() {
                if (this.projectActivityStatsForLastHour.stats) {
                    return this.projectActivityStatsForLastHour.stats.completed + ' completes in the past hour';
                }
                return null;
            },

            timeLeft() {
                if (this.projectActivityStatsForLastHour.stats) {
                    const now = moment.utc();

                    const startDate = moment.utc(this.projectActivityStatsForLastHour.meta.start_date);
                    const endDate = moment.utc(this.projectActivityStatsForLastHour.meta.end_date);

                    if (now.isAfter(endDate)) {
                        return 0;
                    }

                    const minsTotal = moment.duration(endDate.diff(startDate)).as('minutes');
                    const minsRemaining = moment.duration(endDate.diff(now)).as('minutes');

                    return Math.round(minsRemaining / minsTotal * 100);
                }
            }
        },

        created() {
            this.$emit('settings', {title: 'Project leader', info: 'Most active project', configs: []});

            Bus.$on('refresh-widget-' + this.name, () => {
                this.loadData(true);
            });
        },

        mounted() {
            this.loadData();
        },
        methods: {

            ...mapActions('DashBoard', [
                'getProjectActivityStatsForLastHour',
            ]),

            color(percent) {
                if (percent >= 70) return 'green';
                if (percent >= 49) return 'primary';
                if (percent >= 10) return 'yellow';
                return 'red';
            },

            loadData(force = false) {

                this.$emit('loading-started');

                this.getProjectActivityStatsForLastHour(force)
                    .then(() => {
                        this.$emit('loading-ended');

                        if (this.projectActivityStatsForLastHour === null) {
                            this.$emit('insufficient-data', {
                                title: 'No project activity found',
                                subTitle: 'In the past hour'
                            });
                        } else {
                            this.$emit('sufficient-data');
                        }
                    })
                    .catch(error => {
                        this.$emit('loading-ended');
                        Bus.$emit('flash-message', {type: 'error', message: 'Project leader failed to load!'});
                    });
            }
        }
    }
</script>

<style scoped>
    .v-sheet--offset {
        top: -24px;
        position: relative;
        height: 75px;
    }

    .project-name {
        border-bottom: 2px solid grey;
        overflow-x: hidden;
        display: inline-block;
    }
</style>
